import { FC } from 'react';
import {
  Gender,
  getPriceInCentimes,
  locationOfCourse,
  SearchAnnouncePaginatedQueryDto,
  SortCriteria,
} from '@les-sherpas/sherpas-toolbox';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import {
  defaultFilters,
  MAX_PRICE_SEARCH_VALUE,
} from '@/components/Search/components/Filters/Filters.stub';
import Search from '@/components/Search/Search';
import {
  ASCENDING_PRICE,
  getSearchResult,
  sortCriteria,
  sortCriteriaDefaultValue,
} from '@/components/Search/utils';
import { apiGetSubjects } from '@/shared/API/apiGetSubjects';

const Teachers: FC = () => {
  const { query } = useRouter();
  const defaultAddress = query.address as string;
  const defaultSubject = query.subject as string;

  return (
    <Search defaultAddress={defaultAddress} defaultSubject={defaultSubject} />
  );
};

export async function getServerSideProps() {
  const {
    filters: { minPrice, subject, address },
  } = defaultFilters;
  const searchInput: SearchAnnouncePaginatedQueryDto = {
    filters: {
      onlyCertifiedSherpas: false,
      onlyAvailableSherpas: false,
      onlyAnswerFastSherpas: false,
      gender: Gender.Other,
      educationalStages: [],
      availabilities: [],
      minPrice: getPriceInCentimes(minPrice),
      maxPrice: getPriceInCentimes(MAX_PRICE_SEARCH_VALUE),
      subject: subject || '',
      address,
      isFromSeo: false,
      alreadyFetchedIds: [],
      courseLocations: [locationOfCourse.atHome, locationOfCourse.online],
    },
    pagination: {
      currentPage: 1,
      sortCriteria: (sortCriteriaDefaultValue ===
      sortCriteria.indexOf(ASCENDING_PRICE)
        ? SortCriteria.Price
        : sortCriteria[sortCriteriaDefaultValue]) as SortCriteria,
      sortByDescending: !(
        sortCriteriaDefaultValue === sortCriteria.indexOf(ASCENDING_PRICE)
      ),
    },
  };
  const queryClient = new QueryClient();
  await Promise.all([
    queryClient.prefetchQuery(['subject'], apiGetSubjects),
    queryClient.prefetchQuery(['search', searchInput], () =>
      getSearchResult(searchInput)
    ),
  ]);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      isTvBannerDisplayed: true,
    },
  };
}

export default Teachers;
